import { SVGProps, Ref, forwardRef } from 'react';

export const LabelEyeFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="M12 9.5c-1.875 0-2.5 1.25-2.5 2.5s.625 2.5 2.5 2.5 2.5-1.25 2.5-2.5c0-.32-.04-.639-.133-.937-.143.254-.414.437-.867.437-.75 0-1-.5-1-1 0-.346.12-.692.441-.872A3.2 3.2 0 0 0 12 9.5"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 1C3.75 1 1 6.5 1 12s2.75 11 11 11 11-5.5 11-11S20.25 1 12 1M4.5 12c.313 1.25 3.75 5 7.5 5s7.188-3.75 7.5-5c-.312-1.25-3.75-5-7.5-5s-7.187 3.75-7.5 5"
            fill="currentColor"
        />
    </svg>
));
LabelEyeFilledSize24Glyph.displayName = 'LabelEyeFilledSize24Glyph';
